export default "__VITE_ASSET__C0p4B8LN__"